import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl = `${environment.cmiApiUri}`;

  constructor(private httpClient: HttpClient) {}

  isUserSubscribed(email: string): Observable<boolean> {
    if (!email || email.trim().length === 0) {
      //remove this logic
      return of(false);
    }
    return of(true);
  }

  toggleUserSubscription(email: string): Observable<boolean> {
    const url = `${this.baseUrl}/api/emailnotification/toggleUserSubscription`;
    return this.httpClient.post<boolean>(url, { email: (email ?? '').trim() });
  }
}
